<template>
  <PreviewImageButtonPlaceholder
    class="style-color-preview-image"
    :size="size">
    <template #overlay>
      <StyleColorQuickActionsPlaceholder
        :orientation="actionButtonOrientation"
        :size="size === 'auto' ? 'medium' : size"/>
    </template>
  </PreviewImageButtonPlaceholder>
</template>

<script setup>
import PreviewImageButtonPlaceholder from './PreviewImageButtonPlaceholder.vue'
import StyleColorQuickActionsPlaceholder from './StyleColorQuickActionsPlaceholder.vue'

defineProps({
  actionButtonOrientation: {
    type: String,
    default: 'vertical',
    validator: value => ['vertical', 'horizontal'].includes(value)
  },
  size: {
    type: String,
    default: 'auto',
    validator: value => ['auto', 'xx-large', 'x-large', 'large', 'medium'].includes(value)
  }
})
</script>

<style lang="scss" scoped>
.style-color-preview-image {
  @include placeholder-loading-animation;
}
</style>
